import APIClient from '../../Services/AxiosClient';

export const fetchContentOrConfig = async (payLoad: any) => {
  try {
    const response: any = await APIClient({
      url: payLoad?.url,
      method: 'get',
      query: payLoad?.queryPayload,
    });
    response && payLoad?.callback && payLoad?.callback(response);
    return response;
  } catch (err) {
    payLoad?.callback && payLoad?.callback(null);
    console.error('Activity : ', err);
    return null;
  }
};
